import fnc from "./commFunction";
import { setSelectedUserInfo } from "../reduxToolkit/reduxIgong";
import { useDispatch } from "react-redux";


function getUserInfo(dispatch, stCode, callback) {   
  fnc.sendAxios('/igongLogin_allRoutes/select/usrInfo', { stCode }, (res) => {
    if (res && Array.isArray(res)) {   
      dispatch(setSelectedUserInfo(res[0]));
      callback();
    } else {
      alert('usrInfo 검색에 실패했습니다.');
    }
  });
}

const fncSql = { 
  getUserInfo,
 }
export default fncSql;


